import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";

const useSessionIdStore = create((set, get) => ({
  initializeSessionId: () => {
    if (!get().sessionId) {
      const newSessionId = uuidv4();
      set({ sessionId: newSessionId });
    }
  },
  sessionId: null,
}));

export { useSessionIdStore };
